import changePage from '@functions/changePage.ts';

import I from '../types.ts';

const initTextHandlers: I['initTextHandlers'] = function () {
    const { notification } = this.props;
    const { type } = notification;

    if (type === 'incomingBeelineCall') {
        const { callDealGroupId, callDealId } = notification;

        if (callDealGroupId && callDealId) {
            const linkNode = this.parent
                .current!.querySelector('.v2notification__description')
                ?.querySelector('._link') as HTMLElement;

            if (linkNode) {
                linkNode.onclick = () => {
                    changePage({
                        pageName: 'recruit-deals-group-inner-main',
                        ids: { 3: callDealGroupId, 4: callDealId },
                    });
                };
            }
        }
    }
};

export default initTextHandlers;
